import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { red, green, yellow } from '@mui/material/colors';
import { Checkbox } from '@mui/material';

function BotonSemaforoComponent({ defaultValue, label, onChange }) {

    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        onChange(label, event.target.value); 
    };

    const controlProps = (item) => ({
        checked: selectedValue === item,
        onChange: handleChange,
        value: item,
        name: `${label}-checkbox-demo`,
        inputProps: { 'aria-label': item },
    });

    return (
        <Fragment>
            <Checkbox
                {...controlProps('v')}
                defaultChecked={selectedValue === 'v'}
                sx={{
                    color: green[800],
                    '&.Mui-checked': {
                        color: green[800]
                    }
                }}
            />
            <Checkbox
                {...controlProps('a')}
                defaultChecked={selectedValue === 'a'}
                sx={{
                    color: yellow[800],
                    '&.Mui-checked': {
                        color: yellow[800]
                    }
                }}
            />
            <Checkbox
                {...controlProps('r')}
                defaultChecked={selectedValue === 'r'}
                sx={{
                    color: red[800],
                    '&.Mui-checked': {
                        color: red[800]
                    }
                }}
            />
        </Fragment>
    );
};


export default withRouter(BotonSemaforoComponent)
